export default __webpack_public_path__ + "static/media/image.032a70be.svg";